import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import usePermission from "../../utils/usePermission";
import ReportApiViewController from "../../redux/actions/ReportApiAction";
import { FormControl, InputLabel,Select, MenuItem } from "@mui/material";
import { Row, Col, Form} from "react-bootstrap";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import { IconButton, Tooltip,Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";

const ReportListPage =() =>{
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const buttonRef = useRef(null);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const { getEmployeeForReport, generatePFECRReport, genrateESICReport } = ReportApiViewController();
  const { report_data} = useSelector((state) => state.report);
  const { hasPermission } = usePermission();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  useEffect(() => {
    dispatch(getEmployeeForReport());
  }, []);

  const clearEmployeeSelection = () => {
  if (gridRef.current) {
    gridRef.current.deselectAll(); // gridRef has AG Grid API
  }
  setSelectedRows([]);
  setShowSuccessDialog(false);
};
 

  const monthOptions = [
  { value: 1, name: "January" },
  { value: 2, name: "February" },
  { value: 3, name: "March" },
  { value: 4, name: "April" },
  { value: 5, name: "May" },
  { value: 6, name: "June" },
  { value: 7, name: "July" },
  { value: 8, name: "August" },
  { value: 9, name: "September" },
  { value: 10, name: "October" },
  { value: 11, name: "November" },
  { value: 12, name: "December" },
];

const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= 2020; year--) {
    years.push(year);
  }
  return years;
};

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
      colId: "checkboxColumn",
      flex: 1
    },
    {
      headerName: "Emp ID",
      field: "employee_id",
      flex: 1,
      maxWidth: 80,
      pinned: "left"
    },
    {
      headerName: "Name",
      valueGetter: (params) =>
        `${params.data.first_name} ${params.data.last_name}`,
      flex: 1
    },
   {
  headerName: "PF_ECR",
  field: "pf_ecr",
  flex: 1,
  cellRenderer: (params) => {
    return (
      <Tooltip title="Download PF ECR">
        <IconButton
          color="primary"
          size="small"
        onClick={() =>
            dispatch(
              generatePFECRReport({
               employee_id: params.data.id, // individual employee ID
                month: `${selectedYear}-${String(selectedMonth).padStart(2, "0")}`,
              })  
            )

          }
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>
    );
  }
},
{
  headerName: "ESIC",
  field: "esic",
  flex: 1,
  cellRenderer: (params) => {
    return (
      <Tooltip title="Download ESIC">
        <IconButton
          color="primary"
          size="small"
        onClick={() =>
            dispatch(
              genrateESICReport({
                employee_id: [params.data.id], // single employee
                month: `${selectedYear}-${String(selectedMonth).padStart(2, "0")}`,
              })
            )
          }
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>
    );
  }
},

  ];

  return (
    <div>
      <div className="d-flex flex-wrap mb-3" style={{ gap: "12px", alignItems: "center" }}>

  {hasPermission("report_management", "export") && (
  <>
    <Button
     ref={buttonRef}
    variant="contained"
              disabled={selectedRows.length === 0}
              color="primary"
    sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",       
                       
            }}
    onClick={() => {
        const employeeIds = selectedRows.map((row) => row.id); // employee_id in API = id in row
        dispatch(
          generatePFECRReport({
            employee_id: employeeIds,
            month: `${selectedYear}-${String(selectedMonth).padStart(2, "0")}`,
          })
        ).then(() => {
    setShowSuccessDialog(true);
  });
      }}
    >
      <DownloadIcon fontSize="small" className="me-1" />
       PF_ECR
    </Button>

    <Button
    ref={buttonRef}
    variant="contained"
              disabled={selectedRows.length === 0}
              color="primary"
    sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",       
                       
            }}
     
   onClick={() => {
    const employeeIds = selectedRows.map((row) => row.id); // same as PF_ECR
    dispatch(
      genrateESICReport({
        employee_id: employeeIds,
        month: `${selectedYear}-${String(selectedMonth).padStart(2, "0")}`,
      })
    ).then(() => {
    setShowSuccessDialog(true);
  });
  }}
    >
      <DownloadIcon fontSize="small" className="me-1" />
       ESIC
    </Button>
  </>
)}


  {/* Search bar taking max width */}
  <div style={{ flexGrow: 1 }}>
   <Form.Control
  type="text"
  placeholder="Search employees..."
  style={{ height: "40px" }}
  value={searchTerm}
  onChange={(e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Filter the employees
    const lowercasedValue = value.toLowerCase();
    const filtered = report_data.filter((emp) => {
      return (
        emp.first_name?.toLowerCase().includes(lowercasedValue) ||
        emp.last_name?.toLowerCase().includes(lowercasedValue) ||
        emp.employee_id?.toLowerCase().includes(lowercasedValue) 
      );
    });

    setFilteredEmployees(filtered);
  }}
/>
  </div>
  {/* Page size selector */}
  <PageSizeSelector
    pageSize={pageSize}
    onChange={(e) => setPageSize(Number(e.target.value))}
  />
</div>

 <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Reports List</h3>
          </Col>
          <Col className="d-flex justify-content-end gap-3">
            <FormControl size="small" style={{ minWidth: 120 }}>
              <InputLabel>Month</InputLabel>
              <Select
            value={selectedMonth}
            label="Month"
            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 3 * 48, // 4 items * item height (48px default)
                  overflowY: 'auto',
                },
              },
            }}
          >
            {monthOptions.map((month) => (
              <MenuItem key={month.value} value={month.value}>
                {month.name}
              </MenuItem>
            ))}
          </Select>

            </FormControl>

            <FormControl size="small" style={{ minWidth: 120 }}>
              <InputLabel>Year</InputLabel>
              <Select
              value={selectedYear}
              label="Year"
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 3 * 48,
                    overflowY: 'auto',
                  },
                },
              }}
            >
              {generateYears().map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>

            </FormControl>
          </Col>
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={searchTerm ? filteredEmployees : report_data}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>
       <Dialog open={showSuccessDialog} onClose={() => setShowSuccessDialog(false)}>
  <DialogTitle>
    <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
      🎉 Report Generated
    </Typography>
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      You have successfully generated report for <strong>{selectedRows.length}</strong> employee
      {selectedRows.length > 1 ? "s" : ""}. Would you like to clear the current selection?
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    <Box display="flex" justifyContent="space-between" width="100%" px={2}>
      <Button
        onClick={() => setShowSuccessDialog(false)}
        variant="outlined"
        color="inherit"
        sx={{ borderRadius: 2 }}
      >
        Keep Selection
      </Button>

      <Button
        onClick={clearEmployeeSelection}
        variant="contained"
        color="success"
        sx={{ borderRadius: 2 }}
      >
        Clear Selection
      </Button>
    </Box>
  </DialogActions>
</Dialog>




    </div>
  );
}

export default ReportListPage;
